import l from "./index.es242.js";
function u(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = x(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x(t, e) {
  if (t) {
    if (typeof t == "string") return d(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(t, e) : void 0;
  }
}
function d(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function A(t) {
  for (var e = t.images, r = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">', n = 0, f = function() {
    var o = i.value, c = n + 1, a = function(p) {
      return h(p, o.dpi);
    };
    r += "<xdr:oneCellAnchor>", r += "<xdr:from>", r += "<xdr:col>".concat(o.anchor.column - 1, "</xdr:col>"), r += "<xdr:colOff>".concat(typeof o.offsetX == "number" ? a(o.offsetX) : 0, "</xdr:colOff>"), r += "<xdr:row>".concat(o.anchor.row - 1, "</xdr:row>"), r += "<xdr:rowOff>".concat(typeof o.offsetY == "number" ? a(o.offsetY) : 0, "</xdr:rowOff>"), r += "</xdr:from>", r += '<xdr:ext cx="'.concat(a(o.width), '" cy="').concat(a(o.height), '"/>'), r += "<xdr:pic>", r += "<xdr:nvPicPr>", r += '<xdr:cNvPr id="'.concat(c, '" name="').concat(o.title ? l(o.title) : "Picture " + c, '" descr="').concat(o.description ? l(o.description) : "", '"/>'), r += "<xdr:cNvPicPr>", r += '<a:picLocks noChangeAspect="1"/>', r += "</xdr:cNvPicPr>", r += "</xdr:nvPicPr>", r += "<xdr:blipFill>", r += '<a:blip xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:embed="rId'.concat(c, '" cstate="print"/>'), r += "<a:stretch>", r += "<a:fillRect/>", r += "</a:stretch>", r += "</xdr:blipFill>", r += "<xdr:spPr>", r += '<a:prstGeom prst="rect">', r += "<a:avLst/>", r += "</a:prstGeom>", r += "</xdr:spPr>", r += "</xdr:pic>", r += "<xdr:clientData/>", r += "</xdr:oneCellAnchor>", n++;
  }, m = u(e), i; !(i = m()).done; )
    f();
  return r += "</xdr:wsDr>", r;
}
var s = 96, v = 96;
function h(t, e) {
  var r = s;
  return Math.round(t * 9525 * (s / r) * (v / e));
}
export {
  A as default
};
//# sourceMappingURL=index.es213.js.map
